export enum DeliveryServiceType {
    Pvz = "Pvz",
    Dbs = "Dbs",
    Cdbs = "Cdbs",
    Rdbs = "Rdbs",
    Courier = "Courier"
}